import * as Yup from 'yup';

import STRINGS from '../../constants/strings';

export const emailRegex =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}|[a-zA-Z0-9]+\.[^\s]{2,})/;

export const formSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email().required('Email is required'),
  linkedinUrl: Yup.string().matches(emailRegex, 'Linkedin URL should be a valid URL').required(),
  profileUrl: Yup.string().matches(emailRegex, 'Profile URL should be a valid URL'),
  termsOfService: Yup.boolean().oneOf([true], STRINGS.validation.termsAccepted),
});
